export const BASIC = 'BASIC';
export const FREE = 'FREE';
export const STARTER = 'STARTER';
export const PROFESSIONAL = 'PROFESSIONAL';
export const ENTERPRISE = 'ENTERPRISE';
export const orderedProductLevels = [FREE, BASIC, STARTER, PROFESSIONAL, ENTERPRISE];
export const currentOrderedPaidProductLevels = [STARTER, PROFESSIONAL, ENTERPRISE];
export const currentOrderedProductLevels = [FREE, STARTER, PROFESSIONAL, ENTERPRISE];
export const starterGWPOrderedProductLevels = [PROFESSIONAL, ENTERPRISE];
export const currentLowerProductLevels = [FREE, STARTER, PROFESSIONAL];